import { render, staticRenderFns } from "./proprietorPrivateletterList.vue?vue&type=template&id=420d4a58&"
import script from "./proprietorPrivateletterList.vue?vue&type=script&lang=js&"
export * from "./proprietorPrivateletterList.vue?vue&type=script&lang=js&"
import style0 from "./proprietorPrivateletterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports